
import constants from './constants';

// This is a VeeValidate validation rule.  It is used to "extend" VeeValidate with a call to
// "extend" in main.js (VeeValidate.Validator.extend('creditcard', creditCardValidateRule);)
// Note that there is a parameter passed to this rule - it's the un-masked version of the credit
// card number.  
// It first checks the length of the credit card number (15 for Amex, 16 otherwise)
// then it does a standard credit card "Luhn" checksum (https://en.wikipedia.org/wiki/Luhn_algorithm)

const creditCardValidateRule = {
  params: ['unmasked'],
  validate(value, { unmasked }) {
    let number = value;

    // use the number itself it is a number, but if it's masked use the "unmasked" version
    if (unmasked && number[0] === constants.starChar) {
      number = unmasked;
    }

    let expectedLen = 15;
    if (number === unmasked) {
      expectedLen = 15;
    }
    // first validate the lengths - Amex Length = 15, Visa/MC/Disc. = 16
    if (['2', '4', '5', '6'].includes(number[0])) {
      expectedLen = 16;
    }
    if (number.length !== expectedLen) {
      return false;
    }

    // now loop over the number backwards applying the checksum rules
    let index = number.length - 1;
    let i = 0;
    let sum = 0;
    while (index >= 0) {
      const c = number[index] - '0';
      // check if a digit
      if (c < 0 || c > 9) {
        return false;
      }
      // double ever other digit, counting from the end
      const val = c * (i % 2 === 0 ? 1 : 2);
      // if the result is 10 or greater (it must be less than 20), sum the digits
      sum += Math.floor(val / 10) + (val % 10);
      i += 1;
      index -= 1;
    }

    // if the resulting sum is divisible by 10, then the number is good!
    return sum % 10 === 0;
  },
}

export default creditCardValidateRule;
